/* global modForm modUtils Modalytics */
export function heapIdentify() {
	if (window.heap) {
		// Heap Identify only if we have a click key value available
		if (typeof modForm.opts.quadLinkParams.CLK !== 'undefined') {
			if (modUtils.getEnv() === 'production') {
				if ('heap' in window && !window.heap.identity) {
					Modalytics.heap('identify', [modForm.opts.quadLinkParams.CLK]);
				} else if (!window.heapListenerInitialized) {
					window.addEventListener('heapCookieResolved', function() {
						Modalytics.heap('identify', [modForm.opts.quadLinkParams.CLK]);
					}, { once: true });

					window.heapListenerInitialized = true;
				}
			} else {
				Modalytics.heap('identify', [modForm.opts.quadLinkParams.CLK]);
			}
		}
	} else {
		document.addEventListener('heap.loaded', function() {
			heapIdentify();
		});
	}
}
